import { render, staticRenderFns } from "./serviceTime.vue?vue&type=template&id=36413cd6&"
import script from "./serviceTime.vue?vue&type=script&lang=js&"
export * from "./serviceTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports